<template>
  <div
    id="money_lose"
    class="menucontent"
    v-if="showModal"
    style="overflow-y: auto; max-height: 100%"
  >
    <div class="inmenucontent animate__animated animate__bounceIn" :style="{ backgroundImage: createBackgroundString }">
      <button class="hidemenu" @click="hide">
        <i class="fas fa-times"></i>
      </button>
      <div class="ininmnct">
        <div class="menuhead mb-3">
          <i class="fas fa-hand-holding-usd"></i> คืนยอดเสีย
        </div>
        <div class="modal-body -modal-body">
          <div class="x-form-register -register mt-0">
            <div class="row -animatable-container">
              <div class="col order-lg-2 order-0 -form">
                <div class="moneycontainaf1">
                  <div class="pcfriendback">
                    <div class="containlinkcopy">
                      <table style="width: 100%">
                        <tr>
                          <td
                            width="85%"
                            style="text-align: center"
                            colspan="2"
                          >
                            <div class="box1">
                              สามารถรับคืนยอดเสียได้ทุกวัน
                              โดยจะคำนวณจากวันที่รับคืนยอดเสียล่าสุดจนถึงปัจจุบัน
                              ต้องไม่มีเครดิตคงเหลือในกระเป๋า
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width="85%"
                            style="text-align: center"
                            colspan="2"
                          >
                            <br />
                            <div class="">
                              คำนวนยอดจากวันที่
                              <span style="color: green">{{ date_start }}</span>
                              ถึงวันที่
                              <span style="color: green">{{ date_end }}</span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width="85%"
                            style="text-align: center"
                            colspan="2"
                          >
                            <div class="">
                              <hr size="4" color="ffffff" width="100%" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="85%" colspan="2">
                            <div class="">
                              <p style="text-align: center">วิธีคำนวน</p>
                              5% ของ ยอดได้เสีย(รายวัน) สล็อตและคาสิโน โดยคิดจาก
                              ((ยอดฝาก - ถอน) x คืนยอดเสีย%)<br />
                              <span style="text-align: left"
                                >*ยอดฝากต้องมากกว่ายอดถอน</span
                              ><br />
                              <span style="text-align: left"
                                >**ยอดฝากและยอดถอนที่มีผลต่อการคิด คือ
                                ยอดฝากและถอนที่เกิดขึ้นหลังจากที่เคยรับยอดเสียครั้งล่าสุด</span
                              ><br />
                              <span style="text-align: left"
                                >***รับยอดเสียได้วันละ 1 ครั้ง เท่านั้น
                                รีเซตสิทธิ์ เวลา 23.59 น.</span
                              >
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width="85%"
                            style="text-align: center"
                            colspan="2"
                          >
                            <div class="">
                              <hr size="4" color="ffffff" width="100%" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="50%" style="text-align: left">
                            <div class="">สรุปยอดเสียที่ได้รับ</div>
                          </td>
                          <td width="50%" style="text-align: right">
                            <div class="">
                              <span style="color: green; font-size: 16px">{{
                                moneyLose
                              }}</span
                              >&nbsp;&nbsp;บาท
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width="85%"
                            style="text-align: center"
                            colspan="2"
                          >
                            <div class="">
                              <button
                                class="loginbtn"
                                type="submit"
                                @click="debounceSubmitReceive"
                                :disabled="isActionInProgress"
                                id="submitReturn"
                              >
                               <i class="fal fa-money-bill"></i> รับคืนยอดเสีย
                              </button>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <br />
                <div class="friendcontent">
                  <div
                    style="
                      margin-top: 15px;
                      position: relative;
                      text-align: center;
                      z-index: 1000;
                      position: relative;
                    "
                  >
                    <span class="detailaf">ยอดที่นำมาคำนวณคืนยอดเสีย </span>
                  </div>
                  <div class="divoffriends">
                    <div  style="vertical-align: top">
                      <div>
                        <table style="width: 100%">
                          <tr>
                            <td style="width: 50%">
                              <table style="width: 100%">
                                <tr>
                                  <td
                                    style="
                                      position: relative;
                                      text-align: center;
                                      width: 50%;
                                    "
                                    colspan="2"
                                  >
                                    <span> ฝาก </span>
                                  </td>
                                </tr>
                                <tr
                                  v-for="(dp, index3) in deposit"
                                  :key="index3"
                                >
                                  <td
                                    style="
                                      position: relative;
                                      text-align: center;
                                      width: 50%;
                                      font-size: 10px;
                                    "
                                  >
                                    <span>{{ dp.date }}</span>
                                  </td>
                                  <td
                                    style="
                                      position: relative;
                                      text-align: center;
                                      width: 50%;
                                      font-size: 10px;
                                      border-right: 1px solid;
                                    "
                                  >
                                    <span>{{ dp.amount }}</span>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td style="width: 50%; vertical-align: top;">
                              <table style="width: 100%">
                                <tr>
                                  <td
                                    style="
                                      position: relative;
                                      text-align: center;
                                      width: 50%;
                                    "
                                    colspan="2"
                                  >
                                    <span> ถอน</span>
                                  </td>
                                </tr>
                                <tr
                                  v-for="(wd, index2) in withdraw"
                                  :key="index2"
                                >
                                  <td
                                    style="
                                      position: relative;
                                      text-align: center;
                                      width: 50%;
                                      font-size: 10px;
                                    "
                                  >
                                    <span>{{ wd.date }}</span>
                                  </td>
                                  <td
                                    style="
                                      position: relative;
                                      text-align: center;
                                      width: 50%;
                                      font-size: 10px;
                                    "
                                  >
                                    <span>{{ wd.credit_up }}</span>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
                <div
                  class=""
                  style="position: relative; text-align: center; width: 100%"
                >
                  <span style="font-size: 11px"
                    >คำนวนยอดจากวันที่
                    <span style="color: green">{{ date_start }}</span>
                    ถึงวันที่ <span style="color: green">{{ date_end }}</span>
                  </span>
                </div>
                <br />
                <div class="friendcontent">
                  <div
                    style="
                      margin-top: -20px;
                      position: relative;
                      text-align: center;
                      z-index: 1000;
                      position: relative;
                    "
                  >
                    <span class="detailaf">ประวัติรับยอดเสีย </span>
                  </div>
                  <div class="divoffriends">
                    <div>
                      <div>
                        <table style="width: 100%">
                          <tr>
                            <th
                              style="
                                position: relative;
                                text-align: center;
                                width: 33%;
                              "
                            >
                              <span> วันที่</span>
                            </th>
                            <th
                              style="
                                position: relative;
                                text-align: center;
                                width: 33%;
                              "
                            >
                              <span>ยอดเสีย</span>
                            </th>
                            <th
                              style="
                                position: relative;
                                text-align: center;
                                width: 33%;
                              "
                            >
                              <span>สถานะ</span>
                            </th>
                          </tr>
                          <tr v-for="(re, index1) in history" :key="index1">
                            <td
                              style="
                                position: relative;
                                text-align: center;
                                width: 33%;
                                border-right: 1px solid;
                                font-size: 12px;
                              "
                            >
                              <span>{{ re.date }}</span>
                            </td>
                            <td
                              style="
                                position: relative;
                                text-align: center;
                                width: 33%;
                                border-right: 1px solid;
                                font-size: 12px;
                              "
                            >
                              <span>{{ re.credit }}</span>
                            </td>
                            <td
                              style="
                                position: relative;
                                text-align: center;
                                width: 33%;
                                font-size: 12px;
                              "
                            >
                              <span>สำเร็จ</span>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlaymenu"></div>
  </div>
</template>

<script>
import { HTTP } from "@/services/http-common";
import { mapGetters } from "vuex";
export default {
  name: "returnlose-component",
  data() {
    return {
      showModal: false,
      windowWidth: window.innerWidth,
      returnModal: false,
      moneyLose: "",
      withdraw: [],
      deposit: [],
      isLoading: false,
      fullPage: false,
      loader: "bars",
      date_start: "",
      date_end: "",
      history: "",
      isActionInProgress: false,
      debounceTimeout: null,
    };
  },
  methods: {
    show() {
      this.fetchData();
    },
    hide() {
      this.showModal = false;
      this.$emit("OpenMenuModalProp", true);
    },
    debounceSubmitReceive() {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.onSubmitReceive();
    }, 1500); // Adjust the delay as needed
  },
    onSubmitReceive() {
      if (this.moneyLose != 0) {
        this.isLoading = true;
        // document.getElementById("submitReturn").disabled = true;
        HTTP.get(`member/returnlose?receive`)
          .then((resp) => {
            // document.getElementById("submitReturn").disabled = false;
            if (resp.data.status != undefined && !resp.data.status) {
              this.hide();
              this.$toast.error(
                resp.data.msg != undefined
                  ? resp.data.msg
                  : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
              );
            } else {
              this.hide();
              this.fetchUserProfile();
              this.$toast.success(
                resp.data.msg != undefined ? resp.data.msg : "สำเร็จ"
              );
            }
          })
          .catch((err) => {
            this.$toast.error(
              err.data.msg != undefined
                ? err.data.msg
                : "ไม่สามารถทำรายการได้ กรุณาลองใหม่"
            );
          })
          .finally(() => {
          this.isLoading = false;
          this.isActionInProgress = false;
        });
          // .then(() => {
          //   this.isLoading = false;
          // });
      } else {
        this.$toast.error("ไม่มียอดเสีย");
      }
    },
    fetchData() {
      HTTP.get(`member/returnlose`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่"
            );
          } else {
            this.showModal = true;
            this.moneyLose = resp.data.data;
            this.date_start = resp.data.start_at;
            this.date_end = resp.data.end_at;
            this.deposit = resp.data.deposit;
            this.withdraw = resp.data.withdraw;
            this.history = resp.data.lose_data;
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่"
          );
        });
    },
  },computed: {
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(140deg, ${this.WebSetting.color1}, #000000 95%), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    },
  }
};
</script>

<style scoped>
.-icon {
  color: white;
}
.box1 {
  background-color: rgb(135 135 135 / 50%);
  border-radius: 10px;
  color: rgb(255, 255, 255);
}
.line1 {
  width: 100%;
  color: #fff;
}
.moneycontainaf {
  width: 100%;
  background: #0000003d;
  border-radius: 20px;
  margin-top: 8px;
  text-align: left;
  color: #fff;
  font-size: 14px;
  padding: 30px 40px;
  border: 1px solid #ffe18c;
}
.moneycontainaf1 {
  width: 100%;
  background: #000000c2;
  border-radius: 20px;
  margin-top: 8px;
  text-align: left;
  color: #fff;
  font-size: 14px;
  padding: 15px 30px 30px;
  border: 1px solid #ffe18c;
}
.divoffriends {
  text-align: center;
  background: #000000c2;
  border-radius: 20px;
  margin-top: -10px;
  height: 150px;
  overflow: auto;
  padding: 0 10px;
  padding-top: 10px;
  border: 1px solid #ffe18c;
}
.detailaf {
  background: linear-gradient(to right, #8e7050 0%, #89734c 100%);
  padding: 3px 5px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
}
</style>
